export default { semantic: '3.39', build: 520 }
